export const COUPON_STATUS = {
    WAITING: "대기",
    ACTIVE: "진행",
    STOPPED: "중지",
    EXPIRED: "만료",
    COMPLETED: "완료",
    CANCELED: "취소",
} as const;
